module.exports = __webpack_public_path__ + "img/yaoqingyonghu.0e8a65c1.jpg";